export default __webpack_public_path__ + "static/media/Foto-407-300x200.ec34215c.png";